<template>
  <div>
    <CommonPage>
      <template v-slot:banner>
        <banner />
      </template>
      <template v-slot:mainBox>
        <div class="kp_list"></div>
      </template>
    </CommonPage>
  </div>
</template>

<script>
import CommonPage from '../components/CommonPage.vue'
import banner from './Page/indexComp/pagesIndex.vue'
export default {
  components: {
    CommonPage,
    banner
  },
  data() {
    return {

    }
  },
  created() {

  }
}
</script>

<style scoped>
.banner {
  width: 100%;
  height: 430px;
}

.main_box {
  width: 100%;
}

.kp_list {
  width: 100%;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/view/newIndex.vue